import { SeasonSummaryCard } from '@wehunt/ui'
import { useChronicleSeasonStats } from './useChronicleSeasonStats'

export interface ChronicleOverviewSectionProps {
  /**
   * CLUB-136: "Hunts attended" / "Hours in field" derived by the caller from the
   * ended-hunts data (single source of truth). When provided they override the
   * season-stats endpoint's values for those two headline metrics; the harvest
   * metrics (game reported / downed / observed) still come from the endpoint.
   */
  huntsAttended?: number
  hoursInField?: number
}

export function ChronicleOverviewSection({ huntsAttended, hoursInField }: ChronicleOverviewSectionProps = {}) {
  const season = useChronicleSeasonStats()
  return (
    <SeasonSummaryCard
      huntsAttended={huntsAttended ?? season.huntsAttended}
      hoursInField={hoursInField ?? season.hoursInField}
      gameReported={season.gameReported}
      downed={season.downed}
      observed={season.observed}
      wounded={season.wounded}
      loadFailed={season.isError}
      onRetry={season.retry}
    />
  )
}
